import { useState } from "react";
import { Tabs } from "../../components/tabs/Tabs"
import { ActiveProjectsTabViewWrapper } from "./styles"
import { FloorPlan } from "./floorPlan/FloorPlan";
import { ConstructionStatus } from "./constructionStatus/ConstructionStatus";
import { DownloadDocuments } from "./downloadDocuments.js/DownloadDocuments";

export const ActiveProjectsTabView = () => {
    const tabsList = [
        {
            title: 'Floor Plan',
            view: <FloorPlan />
        }, 
        {
            title: 'Construction Status',
            view: <ConstructionStatus />
        }, 
        {
            title: 'Download Documents',
            view: <DownloadDocuments />
        }
    ]
    const [ activeIdx, setActiveIdx ] = useState(0);
    return (
        <ActiveProjectsTabViewWrapper>
            <Tabs tabsList={tabsList} activeIdx={activeIdx} setActiveIdx={setActiveIdx} />
            { tabsList[activeIdx].view }
        </ActiveProjectsTabViewWrapper>
    )
}